import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorHandlerHelperDirective } from './error-handler-helper.directive.';
import { ErrorHandlerDirective } from './error-handler.directive';
import { KeyValueFilterPipe } from './keyvaluefiler.pipe';
import { MakeCorrectionComponent } from './make-correction.component';
import { ValidationErrorMessageComponent } from './validation-error-message.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    MakeCorrectionComponent,
    ValidationErrorMessageComponent,
    ErrorHandlerDirective,
    KeyValueFilterPipe,
    ErrorHandlerHelperDirective
  ],
  exports: [
    MakeCorrectionComponent,
    ValidationErrorMessageComponent,
    ErrorHandlerDirective,
    ErrorHandlerHelperDirective
  ]
})
export class ErrorHandlerModule {}
